export default "__VITE_ASSET__B8jEP4xF__"